let nextIdOffset = 0;

export const getNextId = (highestId: number) => {
  nextIdOffset += 1;
  return highestId + nextIdOffset;
};

export const resetNextIdOffset = () => {
  nextIdOffset = 0;
};
